<h2 class="my-3" [innerHTML]="'common-error-flux-title' | translate"></h2>
<p class="mb-3" [innerHTML]="'common-error-flux-description' | translate"></p>
<div routerLink="/" class="btn btn-primary w-100 mt-5">{{"home-login" | translate}}</div>